import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unavailable-on-production',
  templateUrl: './unavailable-on-production.component.html',
  styleUrls: ['./unavailable-on-production.component.scss']
})
export class UnavailableOnProductionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
